<template>
  <div class="list-box">
    <a-list :grid="grid" :dataSource="dataList">
      <a-list-item slot="renderItem" slot-scope="item, index">
        <slot :item="item" :index="index" name="list-item"></slot>
      </a-list-item>
    </a-list>
    <div style="text-align: right">
      <a-pagination
        v-if="totalCount>currentPageSize"
        :total="totalCount"
        :showTotal="total => `总共 ${total} 条`"
        :pageSize="currentPageSize"
        showSizeChanger
        v-model="currentPage"
        @change="onPageChange"
        @showSizeChange="onShowSizeChange"
      />
    </div>
    <div v-if="loading" class="loading-box">
      <a-spin class="loading" tip="正在加载">
      </a-spin>
    </div>

  </div>
</template>

<script>

export default {
  name: 'CustomPageList',

  props: {
    grid: {
      type: Object,
      default: function() {
        return { gutter: 16, column: 4 }
      }
    },
    pageSize: {
      type: Number,
      default: 8
    },
    pageCount: {
      type: Number,
      default: 1
    },
    loadData: {
      type: Function,
      default: undefined
    },
    firstCall: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      loading: false,
      dataList: [],
      currentPage: 1,
      currentPageSize: 9,
      totalCount: 0
    }
  },
  mounted() {
    this.currentPage = this.pageCount
    this.currentPageSize = this.pageSize
    if (this.firstCall) {
      this.getDataList(this.currentPageSize, this.currentPage)
    }
  },
  watch: {
    pageSize(val) {
      this.currentPageSize = val
      this.getDataList(this.currentPageSize, this.currentPage)
    },
    currentPage(val) {
      this.currentPage = val
      this.getDataList(this.currentPageSize, this.currentPage)
    }
  },
  methods: {
    refresh(bool) {
      if (bool) {
        this.currentPage = 1
        this.getDataList(this.currentPageSize, this.currentPage)
      } else {
        this.getDataList(this.currentPageSize, this.currentPage)
      }
    },
    // refresh() {
    //   this.getDataList(this.currentPageSize, this.currentPage)
    // },
    getDataList(pageSize, pageNo) {
      if (this.loadData) {
        this.loading = true
        const parameter = { pageSize: pageSize, pageNum: pageNo }
        this.loadData(parameter)
          .then(res => {
            if (res) {
              this.totalCount = res.totalCount
              this.currentPage = pageNo
              this.dataList = res.data
            } else {
              this.totalCount = 0
              this.currentPage = 1
              this.dataList = []
            }
            this.currentPageSize = pageSize
          }).catch(reason => console.error(reason)).finally(() => this.loading = false)
      }
    },
    onShowSizeChange(current, pageSize) {
      this.getDataList(pageSize, 1)
    },

    onPageChange(page, pageSize) {
      this.currentPage = page
      this.currentPageSize = pageSize
    }
  }
}
</script>
<style scoped>
.list-box {
  width: 100%;
  text-align: center;
  position: relative;
}

.loading-box {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  background-color: white;
  opacity: 0.8;
}

.loading {
  position: absolute;
  width: 200px;
  height: 200px;
  left: calc(50% - 100px);
  right: calc(50% - 100px);
  top: calc(50% - 100px);
  bottom: calc(50% - 100px);
  text-align: center;
}
</style>